import React from 'react'

import Component from '../../../components/Component'

export default class OppBriefSection extends Component
{
	static TranslationKey;
	static CompletedField = null;

	static sectionTitle = '';
	static sectionHeader = '';
	static sectionSubtitle = '';

    static isCompleted(opportunity) {
        return opportunity.isInterested() || opportunity[this.CompletedField] || opportunity.isAccepted()
    }

    get sectionTitle() {
        return this.constructor.sectionTitle;
    }

    isCompleted(opportunity) {
        return this.constructor.isCompleted(opportunity)
    }

	trans(key) {
		if(this.constructor.TranslationKey) {
			return TB.tryTrans(this.constructor.TranslationKey + '.' + key);
		}

		return key;
	}


	render()
	{
		return (
			<div>
				Placeholder Substep
			</div>
    	);
	}
}